import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatHumanDate } from '@/shared/lib';

type Props = {
  /** Имя автора записи; `null` — запись сделал не пользователь */
  authorName: string | null;
  /** Кем подписана запись без автора */
  defaultAuthorName: string;
  /** Время записи */
  date: string;
};

/** Подпись записи истории: кто её сделал и когда. */
export const HistoryEntryByline: FC<Props> = ({ authorName, defaultAuthorName, date }) => {
  const { i18n } = useTranslation();

  return (
    <span className="text-muted-foreground text-xs">
      {`${authorName ?? defaultAuthorName}, ${formatHumanDate(i18n, date, { withTime: true })}`}
    </span>
  );
};
